module.exports = __webpack_public_path__ + "static/media/292511.88132951.png";